import React from "react";
import { t } from "i18next";
import { LineChartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { 
  Row, 
  Col, 
  Breadcrumb, 
  Card,
  Button, 
  Result
} from "common/elements";
import { Util } from "common/util";

export default function LeaveReport() {
  let navigate = useNavigate();

  const onView = (link) => {
    navigate(link);
  };
  if (!Util.getInstance().hasPermission("view", "leave report")) {
    return <Result
      status="403"
      title="403"
      subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
    />;
  }

  return (
    <>
      <Row style={styles.breadCream}>
        <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              {t("text_dashboard")}
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: "#1d8747" }}>
              {t("text_leave_reports")}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <div style={{ height: "86vh", overflowY: "auto" }}>
        <Row gutter={[32, 32]} style={{ margin: 15 }} id="attendance-report">
          <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
            <Card
              className="report-attendance-card"
              title={
                <div className="title-attendance-report">
                  <LineChartOutlined id="report-line-chart-icon" />
                  <span>Monthly Leave Report</span>
                </div>
              }
              actions={[
                <div className="action-button-view">
                  <Button
                    className="btn-view-attendance"
                    onClick={() => onView("/reports/leaves/daily-leave-status")}
                  >
                    <span>{t("text_view")}</span>
                  </Button>
                </div>,
              ]}
            >
              
            </Card>
          </Col>
          <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
            <Card
              className="report-attendance-card"
              title={
                <div className="title-attendance-report">
                  <LineChartOutlined id="report-line-chart-icon" />
                  <span>{t("text_employee_leave_balance")}</span>
                </div>
              }
              actions={[
                <div className="action-button-view">
                  <Button 
                    className="btn-view-attendance"
                    onClick={() => onView("/reports/leaves/employee-leave-balance")}
                  >
                    <span>{t("text_view")}</span>
                  </Button>
                </div>,
              ]}
            >
            </Card>
          </Col>
          <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
            <Card
              className="report-attendance-card"
              title={
                <div className="title-attendance-report">
                  <LineChartOutlined id="report-line-chart-icon" />
                  <span>{t("text_employee_book_balance")}</span>
                </div>
              }
              actions={[
                <div className="action-button-view">
                  <Button 
                    className="btn-view-attendance"
                    onClick={() => onView("/reports/leaves/employee-leave-book-balance")}
                  >
                    <span>{t("text_view")}</span>
                  </Button>
                </div>,
              ]}
            >
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

const styles = {
  generalSearch: {
    width: 200,
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  breadCream: {
    paddingBottom: 15,
    backgroundColor: "#EFF3F6",
  },
};
